import script from "./OrderType.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderType.vue?vue&type=script&setup=true&lang=js"

import "./OrderType.vue?vue&type=style&index=0&id=57ce9761&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ce9761"]])

export default __exports__